import Upsertable from '@/models/Upsertable'
import { useSurveyResponseAnswerStore } from '@/stores/surveyResponseAnswerStore'
import { useModelName } from '@/composables/useModelName.js'
import { ModelRegistry } from '@/models/modelRegistry.js'

export default class SurveyResponseAnswer extends Upsertable {
  static store() {
    return useSurveyResponseAnswerStore()
  }

  store() {
    return SurveyResponseAnswer.store()
  }

  static all() {
    return SurveyResponseAnswer.store().getAll
  }

  static find(uuid) {
    const obj = SurveyResponseAnswer.store().find(uuid)
    let survey_question = new SurveyResponseAnswer()
    return Object.assign(survey_question, obj)
  }

  static find_all_by_survey_response_uuid(survey_response_uuid) {
    return SurveyResponseAnswer.store()
      .all()
      .filter(
        (survey_response_answer) =>
          survey_response_answer.survey_response_uuid == survey_response_uuid
      )
  }

  /**
   * Mass (weight) inputs use { value, unit } in the UI. Persist as scalar answer + comment metadata.
   */
  beforeSave() {
    const a = this.answer
    if (a == null || typeof a !== 'object' || Array.isArray(a)) return
    if (!Object.prototype.hasOwnProperty.call(a, 'value')) return

    const { value, ...rest } = a
    this.answer = value
    this.comment = JSON.stringify(Object.keys(rest).length ? rest : undefined)
  }
}

useModelName(SurveyResponseAnswer, "SurveyResponseAnswer")
ModelRegistry.register(SurveyResponseAnswer, "SurveyResponseAnswer")